// PhotoID State: 
import React, { useEffect, useMemo, useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  Image
} from "react-native";
import { useTranslation } from 'react-i18next';
import { loadCountries } from "../../../../../services/common.service";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import FlatListDataComponent from "../../../common/FlatListDataComponent";
import RadioSelectedIcon from "../../../../../../../../assets/images/RadioSelectButton.svg";
import Colors from "../../../../../constants/colors";
import { ComponentStyles } from "../../../../../constants/componentStyles";

type StateItem = { stateid: number; stateAbbrivation: string; stateName: string };

type ChooseStateOfIdStepProps = {
  onCountrySelected?: () => void;
};

export default function ReceiverStateOfIdStep({ onCountrySelected }: ChooseStateOfIdStepProps) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const storedIdStateName = useSessionStore((s: SessionState) => (s as any).selectedIdPhotoIdStateName as string | null | undefined);
  const [selectedState, setSelectedState] = useState<string | null>(
    () => (useSessionStore.getState() as any).selectedIdPhotoIdStateName ?? null
  );
  const [states, setStates] = useState<StateItem[]>([]);
  const setSelectedIdPhotoIdStateAbbr = useSessionStore((s: SessionState) => s.setSelectedIdPhotoIdStateAbbr);
  const setSelectedIdPhotoIdStateName = useSessionStore((s: SessionState) => s.setSelectedIdPhotoIdStateName);
  const selectedIdPhotoIdCountry = useSessionStore((s: SessionState) => (s as any).selectedIdPhotoIdCountry);

  useEffect(() => {
    setSelectedState(storedIdStateName ?? null);
  }, [storedIdStateName]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const result = await loadCountries();
        const list = (result?.data ?? []) as any[];
        const targetCountryCode = selectedIdPhotoIdCountry || 'USA';
        const country = list.find((c) => c.CountryCode === targetCountryCode);
        const countryStates: StateItem[] = Array.isArray(country?.States) ? country.States : [];
        setStates(countryStates);
      } catch (e) {
        console.error('Failed to load states', e);
      }
    };
    fetchStates();
  }, [selectedIdPhotoIdCountry]);

  // Filter states by search
  const filteredState = useMemo(() => {
    const q = search.toLowerCase();
    return states.filter((s) => (s.stateName || '').toLowerCase().includes(q));
  }, [states, search]);

    const onSelectState = (item: StateItem) => {
    setSelectedState(item.stateName);
    setSelectedIdPhotoIdStateName?.(item.stateName);
    setSelectedIdPhotoIdStateAbbr?.(item.stateAbbrivation);
    setTimeout(() => {
      onCountrySelected?.();
    }, 200);
  }
  return (
    <View style={styles.containerSticky}>
      <FlatListDataComponent
        stickyHeader
        title={t("YOUR_STATE_OF_ID")}
        subTitle={t("SELECT_STATE_OF_ISSUE")}
        searchPlaceHolder={t("COUNTRY_STEP_SEARCH_PLACEHOLDER")}
        searchValue={search}
        onSearchChangeText={setSearch}
        filteredData={filteredState}
        searchTestID="receiverStateOfIdSearchInput"
        flatListTestID="receiverStateOfIdList"
        renderItem={(item) => (
          <TouchableOpacity
            testID={`receiverStateOfIdOption_${item.stateAbbrivation}`}
            style={styles.countryRow}
            onPress={() => {
              onSelectState(item);
            }}
          >
            <Text style={styles.countryName}>
              {item?.stateName} ({item?.stateAbbrivation})
            </Text>
            <View style={styles.radioButton}>
              {selectedState === item?.stateName && (
                <RadioSelectedIcon width={20} height={20}/>
              )}
            </View>
          </TouchableOpacity>
        )}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 24,
    backgroundColor: Colors.white
  },
  containerSticky: {
    flex: 1,
    minHeight: 0,
    paddingHorizontal: 24,
    backgroundColor: Colors.white,
  },
  searchContent: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: "#F3F4F6",
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 10,
    alignItems: 'center'
  },
  countryRow: {
    backgroundColor: Colors.white,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 0,
    justifyContent: 'space-between'
  },
  flag: {
    fontSize: 22,
    marginRight: 12,
  },
  countryName: {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: 'Rubik',
    lineHeight: 20,
    color: Colors.darkGrey,
    // paddingLeft: 16
  },
  radioOuter: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: "#D1D5DB",
    alignItems: "center",
    justifyContent: "center",
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.radioButtonFilled
  },
  radioOuterSelected: {
    borderColor: "#000",
  },
  radioInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#000",
  },
  selectedText: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: "500",
    color: "#111827",
  },
});
